const isolation = {
    name: "isolation",
    path: "/isolation",
    title: "isolation",
    description: "Utilities for controlling whether an element should explicitly create a new stacking context.",
    value: {
        "isolation": {
            "isolation-auto": "auto",
        "isolation-isolate": "isolate",
        }
    },
    exampleData: [
        {
            "title": "isolate, isolation-auto",
            "description": "utilities to control whether an element should explicitly create a new stacking context:",
            "moreDescription": "Note: The isolation property is helpful when used with background-blend-mode or mix-blend-mode.",
            "parentClass": "max-w-lg",
            "example": {
                "element": "",
                "src": [],
                "className": "aspect-3/2 object-cover w-full rounded-lg overflow-hidden",
                "code": `
<div class="isolate ...">
  <!-- ... -->
</div>
                `
            }
        },
        {
            "title": "isolation",
            "description": "utility with a breakpoint variant like md: to only apply the utility at medium screen sizes and above:",
            "moreDescription": "",
            "parentClass": "max-w-lg",
            "example": {
                "element": "",
                "src": [],
                "className": "aspect-3/2 object-cover w-full rounded-lg overflow-hidden",
                "code": `
<div class="isolate md:isolation-auto ...">
  <!-- ... -->
</div>
                `
            }
        }
        
    ],
};

export default isolation;